<template>
  <div class="filter-container">
    <div class="filter-header" @click="showFilter = !showFilter">
      <div class="filter-title">
        <i class="fa fa-filter" aria-hidden="true"></i>
        フィルター設定
      </div>
      <a class="text--underline">
        <i class="fa" :class="showFilter ? 'fa-caret-up' : 'fa-caret-down'" aria-hidden="true"></i>
        {{ showFilter ? '閉じる' : '開く' }}
      </a>
    </div>
    <div class="filter-content" :class="{ 'is-open': showFilter }">
      <div class="flexbox gap-20">
        <div class="filter-keyword">
          <span class="search-icon-left">🔎</span>
          <input type="text" class="search-input" v-model="search" @keyup.enter="handleFilter" placeholder="ASIN、SKU、FNSKU、商品名" autocomplete="off">
          <button class="clear-search" @click="clearSearch()">✕</button>
        </div>
        <div class="filter-actions">
          <button class="btn btn-primary mr-r-10" @click="handleFilter()">
            <i class="fa fa-search" aria-hidden="true"></i> 検索
          </button>
        </div>
      </div>

      <div>
        <div class="ftabs" role="tablist">
          <button
            v-for="[key, label] in visibleTabs"
            :key="key"
            type="button"
            class="ftab"
            :class="{ on: activeTab === key }"
            @click="activeTab = key"
          >
            {{ label }}
            <span v-if="tabBadgeCount(key)" class="badge">{{ tabBadgeCount(key) }}</span>
          </button>
        </div>
        <div class="fpanel">
          <div v-for="[key] in visibleTabs" :key="key" class="fpane" :class="{ on: activeTab === key }">
            <div v-if="key === 'amount'" class="box-options">
              <label class="cb" :class="{ checked: filters.amountReceived, zero: optionCount(key, null) === 0 && !filters.amountReceived }">
                <input type="checkbox" :checked="filters.amountReceived" @change="toggleAmount">
                <span>
                  Amazon倉庫の受取金額がSTOCKCREW倉庫より低い商品
                  <span class="num">({{ optionCount('amount', null) }})</span>
                </span>
              </label>
            </div>
            <div v-else class="box-options">
              <label
                v-for="[id, text] in OPTIONS[key]"
                :key="id"
                class="cb"
                :class="{ checked: isOptionChecked(key, id), zero: optionCount(key, id) === 0 && !isOptionChecked(key, id) }"
              >
                <input type="checkbox" :checked="isOptionChecked(key, id)" @change="toggleOption(key, id)">
                <span>
                  {{ text }}
                  <span v-if="optionCount(key, id) !== null" class="num">({{ optionCount(key, id) }})</span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedChips.length" class="sel-summary-box">
      <span class="sel-summary-label">選択中の条件:</span>
      <span v-for="chip in selectedChips" :key="chip.key + '-' + chip.id" class="chip">
        {{ chip.label }}
        <button type="button" class="chip-x" @click="removeChip(chip)">✕</button>
      </span>
      <button type="button" class="chip-clear-all" @click="resetFilters"><i class="fa fa-undo" aria-hidden="true"></i>すべてクリア</button>
    </div>
  </div>
</template>

<script>
import { OPTIONS, TABS, NO_COUNT_KEYS, countFor } from '../../common/filterLogic'

const GROUP_LABEL = {
  judgmentStatus: 'ステータス',
  stockStatus: '在庫数',
  warehouse: '倉庫',
  adStatus: '広告運用',
  videoStatus: '動画',
  pickupStatus: 'ピックアップ'
}

export default {
  props: {
    allData: {
      type: Array,
      default: () => []
    },
    isBasicPlan: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showFilter: true,
      search: '',
      appliedKeyword: '',
      activeTab: 'judgmentStatus',
      OPTIONS
    }
  },
  created () {
    this.$store.commit('loadProductFilters', { storageKey: this.filterStorageKey })
  },
  computed: {
    filters () {
      return {
        ...this.$store.getters.getProductFilters
      }
    },
    filterStorageKey () {
      return `${this.$store.getters.getUser.sellerId}-productFilters`
    },
    visibleTabs () {
      return TABS.filter(([key]) => !(key === 'pickupStatus' && this.isBasicPlan))
    },
    selectedChips () {
      const chips = []
      if (this.appliedKeyword && this.appliedKeyword.trim()) {
        chips.push({ key: 'keyword', id: null, label: `キーワード: ${this.appliedKeyword}` })
      }
      Object.keys(GROUP_LABEL)
        .filter(key => !(key === 'pickupStatus' && this.isBasicPlan))
        .forEach(key => {
          OPTIONS[key].forEach(([id, text]) => {
            if (this.filters[key].includes(id)) {
              chips.push({ key, id, label: `${GROUP_LABEL[key]}: ${text}` })
            }
          })
        })
      if (this.filters.amountReceived) {
        chips.push({ key: 'amount', id: null, label: '受取金額: Amazon < STOCKCREW' })
      }
      return chips
    }
  },
  methods: {
    tabBadgeCount (key) {
      if (key === 'amount') return this.filters.amountReceived ? 1 : 0
      return OPTIONS[key].filter(([id]) => this.filters[key].includes(id)).length
    },
    isOptionChecked (key, id) {
      return this.filters[key].includes(id)
    },
    optionCount (key, id) {
      if (NO_COUNT_KEYS.includes(key)) return null
      return countFor(key, id, this.allData, this.filters, this.search, this.isBasicPlan)
    },
    toggleOption (key, id) {
      const arr = this.filters[key]
      const index = arr.indexOf(id)
      index === -1 ? arr.push(id) : arr.splice(index, 1)
      this.handleFilter()
    },
    toggleAmount () {
      this.filters.amountReceived = !this.filters.amountReceived
      this.handleFilter()
    },
    removeChip (chip) {
      if (chip.key === 'keyword') {
        this.clearSearch()
        return
      }
      if (chip.key === 'amount') {
        this.filters.amountReceived = false
        this.handleFilter()
        return
      }
      this.toggleOption(chip.key, chip.id)
    },
    clearSearch () {
      this.search = ''
      this.handleFilter()
    },
    handleFilter () {
      this.appliedKeyword = this.search
      this.$store.commit('saveProductFilters', {
        data: { ...this.filters },
        storageKey: this.filterStorageKey
      })
      this.$emit('handleFilter', this.search)
    },
    resetFilters () {
      this.search = ''
      this.appliedKeyword = ''
      this.$emit('resetFilters')
      this.$emit('handleFilter', this.search)
    }
  }
}
</script>
<style scoped>
.filter-container {
  background-color: #f2f7fa;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.filter-title {
  font-size: 20px;
  font-weight: bold;
  .fa {
    font-size: 24px;
    color: #286090;
  }
}

.sel-summary-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #e2f0d9;
  border: 1px solid #a9d18e;
  border-radius: 8px;
}
.sel-summary-label {
  font-weight: bold;
  color: #3c7a1e;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #fff;
  border: 1px solid #a9d18e;
  border-radius: 14px;
  font-size: 13px;
  color: #3c7a1e;
}
.chip-x {
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  color: #c62828;
  font-size: 12px;
  line-height: 1;
}
.chip-clear-all {
  margin-left: auto;
  border: 1px solid #c62828;
  background: #fff;
  color: #c62828;
  border-radius: 14px;
  padding: 4px 12px;
  font-size: 13px;
  cursor: pointer;
}

.filter-row {
  display: flex;
  gap: 15px;
}
.filter-keyword {
  flex: 1;
  position: relative;
  min-width: 280px;
}

.search-icon-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.4);
  font-size: 20px;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 6px;
  padding-left: 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
  color: #000;
}

.search-input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.12);
  border-color: #0066ff;
  box-shadow: 0 0 0 4px rgba(0, 102, 255, 0.1);
}

.clear-search {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
  opacity: 0;
  transition: all 0.3s ease;
}

.search-input:not(:placeholder-shown)+.clear-search {
  opacity: 1;
}

.clear-search:hover {
  color: #000;
}

.filter-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.filter-content.is-open {
  max-height: 1000px;
}

.filter-actions {
  margin-left: auto;
}

.box-options {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 15px;
  align-items: center;
}

.ftabs {
  display: flex;
  gap: 4px;
  border-bottom: 2px solid #337ab7;
  overflow-x: auto;
}
.ftab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  cursor: pointer;
  padding: 7px 16px;
  border: 1px solid #ccc;
  border-bottom: 0;
  border-radius: 6px 6px 0 0;
  background: #e9eef3;
  color: #4a5560;
  font: inherit;
  font-weight: bold;
}
.ftab.on {
  background: #337ab7;
  border-color: #337ab7;
  color: #fff;
}
.ftab .badge {
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  background: #d7262b;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  padding: 0 5px;
}
.fpanel {
  background: #fff;
  border: 1px solid #ccc;
  border-top: 0;
  border-radius: 0 0 8px 8px;
  padding: 12px 14px;
}
.fpane {
  display: none;
}
.fpane.on {
  display: block;
}

.cb {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  font-weight: normal;
}
.cb input {
  margin: 0;
  cursor: pointer;
}
.cb .num {
  color: #6b7785;
  font-size: 12px;
}
.cb.checked {
  font-weight: bold;
}
.cb.zero {
  color: #b0b8c1;
  font-weight: normal;
}
.cb.zero .num {
  color: #b0b8c1;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
/* Tablet */
@media (max-width: 1024px) {
  .filter-row {
    flex-wrap: wrap;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .filter-container {
    padding: 15px;
  }

  .filter-title {
    font-size: 18px;
  }

  .box-options {
    flex-wrap: wrap;
    gap: 8px;
  }

  .filter-keyword {
    width: 100%;
  }

  .search-input {
    font-size: 14px;
    padding: 8px 8px 8px 36px;
  }
}

/* Small mobile */
@media (max-width: 480px) {
  .filter-container {
    padding: 12px;
  }

  .filter-title {
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/productsNew/Search.vue